import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.updatePhotoDescription.success: {
            return action.payload;
        }

        case constants.updatePhotoDescription.error: {
            return initialState;
        }

        case constants.updatePhotoDescription.try: {
            return {};
        }

        default:
            return state;
    }
}